/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

/*

    *** THIS FILE WILL BE UNNECESSARY IN NEW RESPONSIVE PDP WITH INTL. 
        DEPRECATE WHEN NECESSARY ****

 */
'use strict';

const intelligentFormatObj = require('dibs-currency-helpers/intelligentFormatObj');
const get = require('lodash.get');

module.exports = {
    /**
     *
     * @param {object} copy
     * @param {boolean} isSoldIndividually
     * @param {number|string} price
     * @param {string} currency
     * @returns {{string, abbreviation, perItem: string}}
     */
    formatPrice({ copy = {}, isSoldIndividually, price, currency }) {
        const { sign, currencySymbol, number, abbreviation } = intelligentFormatObj(
            price,
            currency
        );
        const string = `${sign} ${currencySymbol}${number}`.trim();

        const priceStates = copy.priceStates || {};
        const perItemCopy = priceStates.perItem
            ? priceStates.perItem
            : copy['cart.priceStates.perItem'];

        let perItem = '';

        if (isSoldIndividually) {
            perItem += ` ${perItemCopy}`;
        }

        return {
            string,
            abbreviation,
            perItem,
        };
    },

    getPerItemOrSetCopy({ copy = {}, setSize = 1, quantity = 1, hasUnlimitedQuantity = false }) {
        if (setSize > 1) {
            const perSetCopy =
                get(copy, 'priceStates.perSet') ||
                get(copy, 'cart.priceStates.perSet') ||
                'per set';
            return ` ${perSetCopy}`;
        } else if (quantity > 1 || hasUnlimitedQuantity) {
            const perItemCopy =
                get(copy, 'priceStates.perItem') ||
                get(copy, 'cart.priceStates.perItem') ||
                'per item';
            return ` ${perItemCopy}`;
        }
        return '';
    },
};



// WEBPACK FOOTER //
// ./assets/js/components/Price/helpers.es.js